import { DynamicFormRequiredType, isCheckboxChangeEventType, type DynamicFormSettings } from '@myosh/odin-components';
import i18next from '../../../../i18n';
import type { FormBuilderField } from '../../../../redux/slices/form-builder-slice';

export const timeFieldFormSettings: DynamicFormSettings = {
  id: 'TimeFieldSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'ignoreUserTimezone',
      fieldType: 'CHECKBOX',
      fieldName: 'ignoreUserTimezone',
      caption: i18next.t('ignore-user-time-zone'),
      required: DynamicFormRequiredType.False,
      permissions: { edit: true, read: true },
      position: 40,
    },
  ],
  fieldValueConverters: {
    CHECKBOX: (value) => {
      if (isCheckboxChangeEventType(value)) {
        return value.checked;
      }
      return false;
    },
  },
};

export const getTimeFieldValues = (field: FormBuilderField) => {
  return {
    ignoreUserTimezone: field.ignoreUserTimezone,
  };
};
